'use strict';

var FirebaseArray = require('./FirebaseArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');

var KayleeWhatsNew = {
    fromJson: fromJson,
    getWhatsNew: getWhatsNew,
};

function fromJson(data) {
    var reqProps = [];
    return FirebaseArray.$fromJson(data, 'WhatsNew', reqProps, reqProps,
        function(data) { return getWhatsNew(); }
    );
}

function getWhatsNew() {
    var key = 'WhatsNew';
    var whatsNew = KayleeCache.get(key);

    if (whatsNew === null) {
        whatsNew = new WhatsNew();
        KayleeCache.put(key, whatsNew);
    }

    return whatsNew;
}

function WhatsNew() {
    this.$nodeType = 'whatsNew';
    FirebaseArray.call(this, KayleeBase.app.database().ref('whatsNew'));
    KayleeUtil.bindPrototypeMethods(WhatsNew.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

WhatsNew.prototype = Object.create(FirebaseArray.prototype);
WhatsNew.prototype.constructor = WhatsNew;

WhatsNew.prototype.$toJson = function() {
    return FirebaseArray.prototype.$toJson.call(this, {}, []);
};

WhatsNew.prototype.toString = function() {
    return '[WhatsNew]';
};

module.exports = KayleeWhatsNew;